@if (formField && formField.type !== 'hidden') {
  <div
    class="field-container"
    [ngStyle]="{ width: formField.size }"
    [style.display]="formField.ownLine ? 'block' : 'inline-block'"
  >
    @if (isDropdown(formField.type)) {
      <mat-form-field
        appearance="outline"
        class="dynamic form-field"
        [color]="Validate() ? theme : errorTheme"
      >
        <mat-label [class.error]="!Validate()">{{
          formField.viewName
        }}</mat-label>
        <mat-select
          (selectionChange)="DropdownChange($event)"
          [value]="formField.value"
        >
          @for (option of formField.options; track option) {
            <mat-option [value]="option.value">
              {{ option.viewName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else if (isOptionInput(formField.type)) {
      <div
        class="d-flex align-items-center justify-content-center gap-md-5 gap-2 flex-wrap"
      >
        @for (option of formField.options; track option) {
          @if (!option.hidden) {
            <button
              (click)="SetValue(option)"
              mat-flat-button
              class="m-0 py-2 px-3 rounded border-1 {{
                formField.value?.toString() === option.value
                  ? 'mon-bg-primary mon-text-primary'
                  : 'mon-bg-transparent text-black'
              }} mon-border-primary border"
              [attr.data-test]="
                'core-dynamic-input-' +
                formField.id +
                '-' +
                (option.value ?? 'none') +
                '-option-button'
              "
            >
              {{ option.viewName }}
            </button>
          }
        }
      </div>
    } @else if (!isDateInput(formField.type)) {
      <mat-form-field
        class="dynamic form-field"
        appearance="outline"
        [color]="Validate() ? theme : errorTheme"
      >
        <mat-label [class.error]="!Validate()"
          >{{ formField.viewName }}{{ required ? '*' : '' }}</mat-label
        >
        @if (formField.data.prefixIcon) {
          <span class="input-prefix-suffix" matPrefix>
            @switch (formField.data.prefixIcon.iconType) {
              @case ('ICON') {
                <mat-icon>{{ formField.data.prefixIcon.value }}</mat-icon>
              }
              @case ('IMAGE') {
                <img src="{{ formField.data.prefixIcon.value }}" />
              }
              @case ('TEXT') {
                <span class="input-prefix-suffix-text">{{ formField.data.prefixIcon.value }}</span>
              }
            }
          </span>
        }
        <input
          [disabled]="disabledInput"
          matInput
          class="{{ formField.data.class }}"
          [attr.data-test]="formField.id"
          type="{{ formField.type === 'number' ? 'text' : formField.type }}"
          [attr.inputmode]="InputMode()"
          [(ngModel)]="formField.value"
          (ngModelChange)="OnInput()"
          (blur)="OnBlur($any($event.target).value)"
        />
        @if (formField.data.sufixIcon) {
          <span matSuffix>
            <mat-icon>{{ formField.data.sufixIcon }}</mat-icon>
          </span>
        }
        @if (!Validate()) {
          <mat-hint class="error">{{ GetValidationErrors() }}</mat-hint>
        }
      </mat-form-field>
    } @else {
      <mat-form-field
        appearance="outline"
        class="dynamic form-field"
        [color]="Validate() ? theme : errorTheme"
      >
        <mat-label [class.error]="!Validate()">{{
          formField.viewName
        }}</mat-label>
        <input
          matInput
          [attr.data-test]="formField.id"
          [(ngModel)]="formField.value"
        />
        <input
          matInput
          [matDatepicker]="picker"
          style="display: none"
          (dateChange)="CheckValidation()"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"
          [attr.data-test]="formField.id"
        >
        </mat-datepicker-toggle>
        <mat-datepicker
          startView="multi-year"
          (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, picker)"
          #picker
        >
        </mat-datepicker>
        @if (!Validate()) {
          <mat-hint class="error">{{ GetValidationErrors() }}</mat-hint>
        }
      </mat-form-field>
    }
  </div>
}
